// inv/src/service-scripts/gaTrack.js
export function gaTrack(eventName, params = {}) {
  if (typeof window === 'undefined') return;
  if (!window.gtag) return;

  const clean = {};
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || typeof v === 'function') continue;
    if (typeof v === 'string') {
      clean[k] = v.slice(0, 300);
    } else if (Array.isArray(v)) {
      clean[k] = v.map(x => (typeof x === 'string' ? x.slice(0, 100) : x)).slice(0, 25);
    } else {
      clean[k] = v;
    }
  }

  try {
    window.gtag('event', eventName, clean);
  } catch (e) {
  }
}

export function sanitizeQuery(q) {
  if (!q || typeof q !== 'string') return '';
  let s = q.trim();
  s = s.replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, '[email]');
  s = s.replace(/\+?\d[\d\s().-]{6,}\d/g, '[phone]');
  return s.slice(0, 300);
}
